export enum EmailCampaignStatus {
    Sent = 'sent',
    Sending = 'sending',
    Scheduled = 'queued',
    Draft = 'draft',
    Incomplete = 'incomplete',
    Spam = 'spam',
    Review = 'review',
    Cancelled = 'cancelled',
    Unknown = 'unknown',
}
